import { Mesh } from '@babylonjs/core';

import type { IPointCloudTreeNode } from './types';

export class PointCloudTree extends Mesh {
  root: IPointCloudTreeNode | null = null;

  constructor(name: string = 'pointCloudTree', scene?: any) {
    super(name, scene);
  }

  initialized() {
    return this.root !== null;
  }
}
